/**
 * The slots Classes' pages offer, so other areas put their parts on them from their own
 * `index.ts`, and Classes its own from its two registries.
 */
export const classSlots = {
  /** Panels: sections of the class form on Create Class and Edit Class, such as Notifications' switch. */
  formSections: 'classes.class-form.sections',
  /** Tabs on Class Details, such as Entitlements' enrollments and Credentials' certificates. */
  detailsTabs: 'classes.class-details.tabs',
  /**
   * Links in Class Details' sidebar, such as Manage Files and Email Students. The instructor
   * dashboard offers those with the ids `roster`, `pre-class-checklist`, `files`, `training-keys`
   * and `attendance-chart` on each of today's sessions.
   */
  detailsSidebar: 'classes.class-details.sidebar',
  /**
   * The base of the learner class page's slots (`detailsSlots`): its header actions take
   * Entitlements' Enroll me, Request and Cancel buttons, and its panels Launch's Microsoft Learn
   * buttons.
   */
  learnerPage: 'classes.learner-class',
  /** Columns: more columns on Class Roster's table, such as Launch's percent complete, one cell per enrollment id. */
  rosterColumns: 'classes.roster.columns',
  /** A column: Entitlements' status control, shown in Class Roster's Enrollment column in place of the status. */
  rosterStatus: 'classes.roster.status',
  /** A column: Entitlements' room control, shown in Class Roster's Room column in place of the room. */
  rosterRoom: 'classes.roster.room',
  /** Actions: beside Class Roster's title, such as Entitlements' Add Students. */
  rosterActions: 'classes.roster.actions',
  /**
   * Actions: on each row of Class Details' Activities tab, such as Launch's launch button. The
   * context's record is the activity; the class is the page's (the route's `publicId`).
   */
  activityLaunch: 'classes.class-details.activity-launch',
  /**
   * Columns, read for their values only: each Enrolled student's percent complete (0 to 100) on
   * the instructor dashboard's sessions today, such as Launch's. One load per session, with its
   * enrollment ids, the class as the record and the API client; the breakdown combines it with the completion
   * status. The first one registered is used, and its header and cell are not shown. It loads only for a
   * viewer holding its `permission`, and a student it leaves out counts as unknown.
   */
  dashboardProgress: 'classes.instructor-dashboard.progress',
  /**
   * Links: the instructor dashboard's quick links. One whose id is a quick link's (`calendar`,
   * `achievements`, `lab-instances`, `current-training` and the rest) makes that one open its
   * page; one with another id is added at the end.
   */
  dashboardLinks: 'classes.instructor-dashboard.links',
  /** Actions: beside each of today's sessions on the instructor dashboard, such as a class training key; the record is the class. */
  dashboardSessionActions: 'classes.instructor-dashboard.session-actions',
  /**
   * Panels, never shown: other areas' dated items on the Student Dashboard's week at a glance and
   * month calendar, such as Entitlements' course assignments. Each is mounted once for both widgets
   * and reports its items with `useStudentCalendarItems`; the record is the signed-in person's User Profile.
   */
  studentCalendarItems: 'classes.student-dashboard.calendar-items',
} as const
